import { render } from "./favorite_button.vue?vue&type=template&id=18a86a20"
import script from "./favorite_button.js?vue&type=script&lang=js"
export * from "./favorite_button.js?vue&type=script&lang=js"

import "./favorite_button.vue?vue&type=style&index=0&id=18a86a20&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__